import { all } from 'redux-saga/effects';

import accountSagas from './account';
import appSagas from './app';
import authenticationSagas from './authentication';
import peopleSagas from './people';
import leadSagas from './lead';
import leadDetailSagas from './leadDetail';

export default function* rootSaga() {
  yield all([
    ...appSagas,
    ...authenticationSagas,
    ...peopleSagas,
    ...accountSagas,
    ...leadSagas,
    ...leadDetailSagas
  ]);
}
